import GameParameterInterface from '@/models/game/parameters/interface'
import { Property } from '@/models/game/property'
import { Prize } from '@/models/game/response/complete'
import GameExecutorInterface from '@/services/game/executor/executor-interface'
import GameProcessor from '@/services/game/processor'
import { ScriptLoader } from '@/util/scriptLoader'

interface GameResult {
  score: number,
}

interface CompletedCallbackParam {
  gameResult: GameResult,
}

export default class MemoryExecutor implements GameExecutorInterface {

  constructor(
    private processor: GameProcessor,
    private property: Property,
    private parameter: GameParameterInterface
  ) { }

  async execute(): Promise<void> {

    const scriptLoader = new ScriptLoader({
      src : this.property.scriptUrl,
      global: 'GAME',
    })

    const game: any = await scriptLoader.load()

    game.setOption({
      ...this.parameter.createSetOption(),
      resource: this.property.resourcePath,
      theme: `${this.processor.gameOrganizer}/${this.property.theme}`,
      nextPageUrl: this.processor.makeGameResultUrl(),
    })
    .setStarted(() => {

      if (!this.processor.playStatusIsStarted) {
        return this.processor.notifyGameStart({})
      }
    })
    .setCompleted(async (param: CompletedCallbackParam) => {

      const resultPrize: Prize = await this.processor.notifyGameCompleteWithScore({
        result: JSON.stringify({
          score: param.gameResult.score,
        }),
      })

      return {
        imageUrl: resultPrize.imageUrl,
        nextPageKind: resultPrize.prizeValue,
      }
    })
    .start()
  }
}
